/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ROUTES } from 'constants/routes'
import { REGISTRATION_STEPS } from 'constants/auth'
import { onShowError } from 'redux-app/modules/alerts'
import {
  plans,
  selectPlan,
  setRenewalPlans,
} from 'redux-app/modules/subscriptions'
import { updateRegistrationStep } from 'redux-app/modules/auth'
import {
  getSubscriptionPlans,
  getSubscriptionPlansForRenew,
  acceptTerms,
  updateShippingInfo,
  changeSubscriptionPlan,
  cancelSubscription,
  renewSubscriptionPlan,
  enrollSubscriptionPlan,
  renewAndChangeSubscriptionPlan
} from 'api/client/actions/subscriptions'
import { updateBillingAddress } from 'api/client/actions/card'
import { getUserDetails } from 'api/client/actions/user'
import { isSelectedPlanAvailable } from 'redux-app/selectors/subscription'
import { history } from 'utils/location'

export const onGetSubscriptionsPlans = () => dispatch => {
  return dispatch(getSubscriptionPlans())
    .then(({ value: { result } }) => {
      dispatch(plans(result))
    })
    .catch((error: any) => {
      dispatch(onShowError(error, {}))
      throw error
    })
}

export const onGetSubscriptionsPlansForRenew = () => dispatch => {
  return dispatch(getSubscriptionPlansForRenew())
    .then(({ value: { result } }) => {
      dispatch(setRenewalPlans(result))
    })
    .catch((error: any) => {
      dispatch(onShowError(error, {}))
      throw error
    })
}

export const onSelectSubscriptionPlan = id => (dispatch, getState) => {
  dispatch(selectPlan(id))
  if (isSelectedPlanAvailable(getState())) {
    history.push(ROUTES.home.signUp)
  } else {
    history.push(ROUTES.home.leaveEmail)
  }
}

export const onAcceptTerms = data => dispatch => {
  return dispatch(acceptTerms(data)).then(() => {
    dispatch(updateRegistrationStep(REGISTRATION_STEPS.congrats))
    return dispatch(getUserDetails())
  })
    .catch(error => {
      dispatch(onShowError(error))
      throw error
    })
}

export const onSaveShippingAddress = formValues => dispatch => {
  return dispatch(updateShippingInfo(formValues))
}

export const onCompleteSavingShippingAddress = () => dispatch => {
  return dispatch(getUserDetails())
}

export const onSaveBillingAddress = formValues => dispatch => {
  return dispatch(updateBillingAddress(formValues))
}

export const onCompleteSavingBillingAddress = () => dispatch => {
  return dispatch(getUserDetails())
}

export const onChangeSubscriptionPlan = (subscriptionPlanId, customerSignature = null) => dispatch => {
  return dispatch(changeSubscriptionPlan(subscriptionPlanId, customerSignature))
    .then(() => dispatch(getUserDetails()))
    .catch(error => {
      dispatch(onShowError(error))
      throw error
    })
}

export const onAcceptRenewSubscriptionPlan = (subscriptionPlanId, customerSignature = null, termsRead = false) => dispatch => {
  return dispatch(renewSubscriptionPlan(subscriptionPlanId, customerSignature, termsRead))
    .then(() => dispatch(getUserDetails()))
    .catch(error => {
      dispatch(onShowError(error))
      throw error
    })
}

export const onAcceptEnrollSubscriptionPlan = (subscriptionPlanId, customerSignature = null) => dispatch => {
  return dispatch(enrollSubscriptionPlan(subscriptionPlanId, customerSignature))
    .then(() => dispatch(getUserDetails()))
    .catch(error => {
      dispatch(onShowError(error))
      throw error
    })
}

export const onAcceptRenewAndChangeSubscriptionPlan = (subscriptionPlanId, customerSignature = null) => dispatch => {
  return dispatch(renewAndChangeSubscriptionPlan(subscriptionPlanId, customerSignature))
    .then(() => dispatch(getUserDetails()))
    .catch(error => {
      dispatch(onShowError(error))
      throw error
    })
}

export const onCancelSubscription = formData => dispatch => {
  return dispatch(cancelSubscription(formData))
    .then(() => dispatch(getUserDetails()))
    .catch(error => {
      dispatch(onShowError(error))
      throw error
    })
}
